import { CreateCompetencePage } from "@features/rh/competences/components/CreateCompetencePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/competences/create")({
  staticData: {
    title: "Nouvelle compétence",
    showInBreadcrumb: true,
  },
  component: CreateCompetencePage,
});
